import {Injectable} from '@angular/core';
import {BehaviorSubject, filter, firstValueFrom, Observable, of, switchMap, tap} from "rxjs";
import {Branch} from "./branch.entity";
import {BranchRepository} from "./branch.repository";

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  private _branch$ = new BehaviorSubject<Branch[]>([]);
  private _filteredBranch$ = new BehaviorSubject<Branch[]>([]);

  constructor(private branchRepo: BranchRepository) {
  }

  get branch(): Observable<Branch[]> {
    return this._branch$;
  }

  set branch(value: Branch[]) {
    this._branch$.next(value);
  }

  get filteredBranch(): Observable<Branch[]> {
    return this._filteredBranch$;
  }

  set filteredBranch(value: Branch[]) {
    this._filteredBranch$.next(value);
  }

  getAllBranchObs(): Observable<Branch[]> {
    return this.branch;
  }

  getAllFilteredBranchObs(): Observable<Branch[]> {
    return this.filteredBranch;
  }

  fetchAllBranch() {
    return this.branchRepo.fetchAllBranch().pipe(
      switchMap(res => of(res.result.data)),
      tap(branch => {
        this.branch = branch;
        if (branch && branch.length > 0) {
          this.filteredBranch = [branch[0]];
        }
      })
    )
  }

  async getJoinFilteredBranchCodes() {
    const filteredBranches$ = this.getAllFilteredBranchObs().pipe(
      filter(branches => branches.length > 0)
    );

    const filteredBranch = await firstValueFrom(filteredBranches$);
    const mapFilteredBranch = filteredBranch.map(branches => branches.branchCode);
    return mapFilteredBranch.join(",");
  }

}
